export default function getPolygonCentroid(points: { x: number; y: number }[]) {
  let a = 0,
    cx = 0,
    cy = 0
  const n = points.length

  for (let i = 0; i < n; i++) {
    const p1 = points[i]
    const p2 = points[(i + 1) % n]
    const cross = p1.x * p2.y - p2.x * p1.y
    a += cross
    cx += (p1.x + p2.x) * cross
    cy += (p1.y + p2.y) * cross
  }

  a *= 0.5
  if (Math.abs(a) < 1e-8) {
    // fallback bbox
    let minX = Infinity,
      minY = Infinity,
      maxX = -Infinity,
      maxY = -Infinity
    for (const p of points) {
      minX = Math.min(minX, p.x)
      minY = Math.min(minY, p.y)
      maxX = Math.max(maxX, p.x)
      maxY = Math.max(maxY, p.y)
    }
    return { x: (minX + maxX) / 2, y: (minY + maxY) / 2 }
  }

  return { x: cx / (6 * a), y: cy / (6 * a) }
}
